export default __webpack_public_path__ + "images/1c39f672-arrow_back_ios_black_24dp.svg";